import NetWork from '../network/index';
import Config from '../config/index';
import Utils from '../utils/util';

const useMock: boolean = Config.get({
    moduleName: 'base',
    key: 'useMock'
});

// 跨商家粘贴数据校验
async function diffBusinessPasteCheck(params): Promise<any> {
    return NetWork.post({
        useMock,
        url: 'pasteDataTransByVenderId',
        requestParams: params
    }).then((listStr: any): Promise<any> => {
        let list: any;

        if (!listStr) {
            list = [];
        }
        else if (typeof listStr === 'string') {
            list = JSON.parse(listStr);

            if (!Utils.isArray(list)) {
                list = [];
            }
        }
        else if (Utils.isArray(listStr)) {
            list = listStr;
        }

        return Promise.resolve(list);
    }).catch((err) => {
        return Promise.reject(err);
    });
};

async function getSubSkuCubeInfo(params): Promise<any> {
    return NetWork.post({
        useMock: false,
        url: 'getSubGoodsDataBySku',
        requestParams: params
    }).then((res: any): Promise<any> => {
        return Promise.resolve(res);
    }).catch((err) => {
        return Promise.reject(err);
    });
}

export default {
    diffBusinessPasteCheck,
    getSubSkuCubeInfo
};
